<p-toast [style]="{ marginTop: '80px' }" position="top-right" key="tc"></p-toast>

<body>
  <div class="dash">
    <app-sidebar></app-sidebar>
    <div class="dash-app">
      <app-header></app-header>
      <main class="dash-content" style="padding: 0; margin: 0">
        <div class="container-fluid">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-2">
                <div class="panel panel-white profile-widget border-top-light-gray" style="background:white">
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="image-container p-0 m-0">
                        <!--  <p-carousel [value]="clinicImagesArray">
                          <ng-template let-img pTemplate="item">
                            <img [src]="img" width="100%" height="400px" />
                          </ng-template>
                        </p-carousel>-->
                        <!-- <p-galleria
                          [value]="clinicImagesArray"
                          [autoPlay]="true"
                          [circular]="true"
                          [showThumbnails]="false"
                        >
                          <ng-template pTemplate="item" let-item>
                            <img
                              [src]="item"
                              alt="item.alt"
                              height="350px"
                              width="100%"
                            />
                          </ng-template>
                        </p-galleria> -->


                        <p-toast position="top-left" key="tl"></p-toast>
                        <button class="cencleupload" id="cencleupload"
                          (click)="cencleuploade()"><span>&times;</span></button>
                        <form (ngSubmit)="onSubmitProfile()" style="text-align: center;">
                          <img [src]="profileImage" id="profileofdoctor" class="avatar mt-1 " alt="avatar" />
                          <div id="uploadimg" class="col-md-12" style="display: none;">
                            <img [src]="selectedImageUrl" class="uploadview">
                            <button type="submit" class="uploadbutton "><span class="spinner-border spinner-border-sm"
                                role="status" aria-hidden="true" *ngIf="isLoading"></span><i class="fa fa-upload"
                                style="font-size: 21px;" *ngIf="!isLoading"></i></button>
                          </div>
                          <label id="selectimage" for="file-input" class="addicon"><i class="fa fa-pencil"></i></label>
                          <!-- <label id="uploadimage1" *ngIf="selectedfile">{{ selectedfile["name"] }}</label> -->
                          <!-- <label id="selectimage" for="file-input" style="   
                                  border: 1px dotted darkgrey; font-weight: bold;color:grey;
                                  padding: 6px;cursor: pointer;" >
                                  <i class="fa fa-plus"></i>  CHANGE PROFILE PIC</label
                                > -->
                          <!-- <button
                                id="uploadimage"
                                class="text-center"
                                  type="submit"
                                  name="Upload"
                                  value="Upload"
                                ><i class="fa fa-upload"></i>  Upload</button> -->
                          <input type="file" id="file-input" (change)="onfilechange($event)"
                            accept="image/x-png,image/gif,image/jpeg" style="display:none;  " />
                        </form>
                      </div>
                    </div>
                    <!-- <div class="col-sm-12"> -->
                    <!-- <div class="details mt-3" style="padding: 0;"> -->
                    <p style="text-align: center;
                                                font-weight: 550;
                                                font-family: 'Open Sans';font-size: 14px;">
                      Dr. {{ docData?.name.toUpperCase() }} <i class="fa fa-sheild"></i>
                    </p>
                    <!-- </div> -->
                    <!-- <div class="row mb-3 p-0 mx-0">
                                        
                                                <div class="container col-md-12 text-center mx-0 p-0">
                                                    <select class="form-control font-weight-bold" style="text-align-last: center" (change)="onChangeClinic($event.target.value)">
                            <option
                              *ngFor="
                                let clinic of clinicArray;
                                let index = index
                              "
                              [value]="index"
                            >
                              {{ clinic.clinicName }}
                            </option>
                          </select>
                                                </div>

                            
                                            </div> -->
                    <!-- </div> -->
                  </div>
                </div>

                <button type="button" class="btn btn-primary" data-toggle="modal" (click)="getreceptionist()"
                  data-target="#exampleModal">
                  Receptionist
                </button>
                <button type="button" class="btn btn-info" data-toggle="modal"
                  data-target="#exampleModal1" (click)="getdoctordata()">Wifi</button>
                <!-- Button trigger modal -->
                <!-- Modal -->
                <div class="modal fade" id="exampleModal1" tabindex="-1" aria-labelledby="exampleModalLabel"
                  aria-hidden="true">
                  <div class="modal-dialog">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Display wifi setting</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <h3>{{doctordata?.name}}</h3>
                        <form [formGroup]="ledddata" (ngSubmit)="updateLed()">
                          <input type="text" formControlName="pass" placeholder="wifi-password">
                          <button type="submit" class="btn btn-primary">Save changes</button>
                        </form>
                      </div>
                      <div class="modal-footer">
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-sm-10">

                <div class="row">
                  <div class="col-sm-12">
                    <div class="panel panel-white border-top-light-gray" style="background: white">
                      <div class="panel-heading" style="border-bottom: 1px solid #efefef;">
                        <h3 class="panel-title">User Info</h3>
                        <div class="controls pull-right">
                          <span class="pull-right clickable" data-toggle="modal" data-target="#myModal">
                            <i style="font-size: 20px" class="fa fa-pencil"></i>
                          </span>
                        </div>
                      </div>
                      <div class="panel-body">
                        <div class="container row">
                          <div class="body-section col-md-4">
                            <h6 style="font-weight:bold" class="section-heading">Name</h6>
                            <p class="section-content">{{ docData?.name }}</p>
                          </div>
                          <div class="body-section col-md-4">
                            <h6 style="font-weight:bold" class="section-heading">Phone</h6>
                            <p class="section-content">{{ docData?.phoneNo }}</p>
                          </div>
                          <div class="body-section col-md-4">
                            <h6 style="font-weight:bold" class="section-heading">Email</h6>
                            <p class="section-content">{{ docData?.email }}</p>
                          </div>
                          <div class="body-section col-md-4">
                            <h6 style="font-weight:bold" class="section-heading">Doctor type</h6>
                            <p class="section-content">
                              {{ docData?.doctorType?.name }}
                            </p>
                          </div>
                          <div class="body-section col-md-4">
                            <h6 style="font-weight:bold" class="section-heading">Degree</h6>
                            <p class="section-content">{{ docData?.degree }}</p>
                          </div>
                          <div class="body-section col-md-4">
                            <h6 style="font-weight:bold" class="section-heading">Consulationfee</h6>
                            <p class="section-content">
                              {{ docData?.consultationFee?.firstVisit }} Rs
                            </p>
                          </div>
                          <div class="body-section col-md-4">
                            <h6 style="font-weight:bold" class="section-heading">Medical Council Member</h6>
                            <p class="section-content">
                              {{ docData?.membership }}
                            </p>
                          </div>
                          <div class="body-section col-md-4">
                            <h6 style="font-weight:bold" class="section-heading">Medical Council ID</h6>
                            <p class="section-content">{{ docData?.mcId }}</p>
                          </div>
                          <div class="body-section col-md-4">
                            <h6 style="font-weight:bold" class="section-heading">Experience</h6>
                            <p class="section-content">
                              {{ docData?.experience }} Year
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>


                  </div>
                  <!-- <div class="row"> -->

                  <div class="col-sm-6">
                    <select class="form-control font-weight-bold mb-5" style="text-align-last: center"
                      (change)="onChangeClinic($event.target.value)">
                      <option *ngFor="
                                            let clinic of clinicArray;
                                            let index = index
                                            
                                          " [value]="index">
                        {{ clinic.clinicName }}
                      </option>
                    </select>
                    <!-- <div class="panel panel-white border-top-green">

                      <div class="panel-heading">
                        <h3 class="panel-title">Clinic Info</h3>
                        <div class="controls pull-right">
                          <span
                            class="pull-right clickable"
                            (click)="editClinic(clinicData)"
                            >
                            <i class="fa fa-pencil"></i>
                          </span>
                        </div>
                      </div>

                      <div class="panel-body">
                        <div class="body-section">
                          <h5 class="section-heading">Clinic Name</h5>
                          <p class="section-content">
                            {{ clinicData?.clinicName }}
                          </p>
                        </div>
                        <div class="body-section">
                          <h5 class="section-heading">Patient Limit</h5>
                          <p class="section-content">
                            {{ clinicData?.patientLimit }}
                          </p>
                        </div>
                        <div class="body-section">
                          <h5 class="section-heading">Working Days</h5>
                          <p class="section-content">
                            {{ clinicData?.weekDays }}
                          </p>
                        </div>
                        <div class="body-section">
                          <h5 class="section-heading">Clinic Opening Time</h5>
                          <p class="section-content">
                            {{ clinicData?.timming?.startTime }}
                          </p>
                        </div>
                        <div class="body-section">
                          <h5 class="section-heading">Clinic Closing Time</h5>
                          <p class="section-content">
                            {{ clinicData?.timming?.endTime }}
                          </p>
                        </div>

                        <div class="body-section">
                          <h5 class="section-heading">Address</h5>
                          <p class="section-content">
                            {{ clinicData?.address.line1 }}
                            {{ clinicData?.address.city }}
                            {{ clinicData?.address.state }}
                          </p>
                        </div>
                        <div class="body-section">
                          <h5 class="section-heading">Pincode</h5>
                          <p class="section-content">
                            {{ clinicData?.address.pincode }}
                          </p>
                        </div>
                      </div>

                    </div> -->

                    <div class="panel panel-white border-top-light-gray" style="background:white">
                      <div class="panel-heading">
                        <h3 class="panel-title">Holidays</h3>
                        <div class="controls pull-right">

                          <span class="pull-right clickable" data-toggle="modal" data-target="#myHoliday">
                            <i class="fa fa-pencil"></i>
                          </span>
                        </div>
                      </div>
                      <div class="panel-body">
                        <div class="body-section">
                          <div *ngFor="let hol of holidayData">
                            <h4 class="section-heading">
                              {{ hol.clinicId.clinicName }}
                            </h4>
                            <h5 class="text-muted">
                              Clinic is closed between {{ hol.startDate }} to {{ hol.endDate }}
                            </h5>
                          </div>
                          <button class="btn btn-danger" *ngIf="holidayData.length > 0" data-toggle="modal"
                            data-target="#deleteHolidayModal">Delete Holiday</button>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="col-sm-6">
                    <div class="panel panel-white border-top-light-gray" style="background:white">
                      <div class="panel-heading">
                        <h3 class="panel-title">Services</h3>
                        <div class="controls pull-right">
                          <span class="pull-right clickable" data-toggle="modal" data-target="#myModalService">
                            <i class="fa fa-pencil"></i>
                          </span>
                        </div>
                      </div>
                      <div class="panel-body">
                        <form class="form-horizontal" [formGroup]="svForm" (ngSubmit)="onSubmitServiceData()">


                          <div class="form-group">

                            <div class="container row">
                              <div class="col-sm-9 ">
                                <p-autoComplete style="width: 100%;" placeholder="Add services"
                                  formControlName="services" [(ngModel)]="texts" [suggestions]="dropdownList"
                                  (completeMethod)="search($event)" [multiple]="true" [style]="{ width: '100%' }"
                                  [inputStyle]="{ width: '15rem' }" (onKeyUp)="onKeyUp($event)"
                                  autoWidth="true"></p-autoComplete>

                              </div>


                              <div class="col-sm-2 offset-md-1">
                                <button class="btn btn-primary" style="border-radius: 50%" type="submit"
                                  [disabled]="isLoading">
                                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isLoading"></span>

                                  <i class="fa fa-plus" *ngIf="!isLoading"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                        <div class="text-center" *ngIf="servicesArray.length == 0">
                          <h5>No Services Added yet</h5>
                        </div>
                        <div *ngIf="servicesArray.length > 0">
                          <div class="body-section px-3" *ngFor="
                            let sinServ of servicesArray;
                            let index = index
                          ">
                            <h5 class="section-heading font-weight-bold">
                              {{ index + 1 }} - {{ sinServ }}
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>

  <div class="dash">
    <app-sidebar [profileImage]="profileImage"></app-sidebar>
    <div class="dash-app">
      <app-header></app-header>
      <main class="dash-content" style="padding: 0; margin: 0"></main>
    </div>

    <div class="modal fade" id="myModal">
      <div class="modal-dialog modal-dialog-scrollable modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" #closebutton>
              &times;
            </button>
          </div>

          <div class="modal-body">
            <form class="form-horizontal" [formGroup]="rdForm" (ngSubmit)="onSubmit()">
              <h3 style="text-align: center">Doctor Update</h3>
              <div class="form-group">
                <label for="name" class="col-sm-3 offset-md-1 control-label">Name</label>
                <div class="col-sm-9 offset-md-1">
                  <input type="text" id="name" placeholder="Name" class="form-control" formControlName="name"
                    autofocus />
                </div>
              </div>
              <div class="form-group">
                <label for="medicalDegree" class="col-sm-3 offset-md-1 control-label">Medical Degree</label>
                <div class="col-sm-9 offset-md-1">
                  <p-multiSelect [options]="degrees" formControlName="degree" inputStyleClass="form-control"
                    autoWidth="false" [style]="{ width: '100%' }"></p-multiSelect>
                </div>
              </div>
              <div class="form-group">
                <label for="doctorType" class="col-sm-3 offset-md-1 control-label">DoctorType</label>
                <div class="col-sm-9 offset-md-1">
                  <select class="form-control" id="doctorType" formControlName="doctorType">
                    <option *ngFor="let singleElem of doctorTypeAray" [value]="singleElem.id">
                      {{ singleElem.name }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label for="clinic" class="col-sm-3 offset-md-1 control-label">Clinic*</label>
                <div class="col-sm-9 offset-md-1">
                  <input type="text" id="clinic" class="form-control" placeholder="Clinic" formControlName="clinic" />
                </div>
              </div>
              <div class="form-group">
                <label for="experience" class="col-sm-3 offset-md-1 control-label">Experience*</label>
                <div class="col-sm-9 offset-md-1">
                  <input type="number" id="experience" class="form-control" placeholder="experience"
                    formControlName="experience" />
                </div>
              </div>

              <div class="form-group">
                <label for="consultationFee" class="col-sm-3 offset-md-1 control-label">Consultation Fee</label>
                <div class="col-sm-9 offset-md-1">
                  <input type="number" id="experience" class="form-control" placeholder="Consultation Fee"
                    formControlName="consultationFee" />
                </div>
              </div>

              <div class="form-group">
                <label for="email" class="col-sm-3 offset-md-1 control-label">Email*
                </label>
                <div class="col-sm-9 offset-md-1">
                  <input type="email" id="email" placeholder="Email" class="form-control" name="email"
                    formControlName="email" />
                  <span class="help-block" *ngIf="
                      !rdForm.get('email').valid && rdForm.get('email').touched
                    ">
                    *this field is invalid
                  </span>
                </div>
              </div>
              <div class="col-sm-9 offset-md-1">
                <button class="btn btn-primary btn-block" style="border-radius: 10px" type="submit"
                  [disabled]="isLoading">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isLoading"></span>

                  Update Doctor
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="myModalClinic">
      <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" #closebutton #closeclinicmodal>
              &times;
            </button>
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            <form class="form-horizontal" [formGroup]="cdForm" (ngSubmit)="onSubmitClinicData()">
              <h5 style="text-align: center">ClinicData Update</h5>

              <div class="form-group">
                <label for="name" class="col-sm-3 offset-md-1 control-label">Clinic Name</label>
                <div class="col-sm-9 offset-md-1">
                  <input type="text" id="name" placeholder="clinic name" class="form-control"
                    formControlName="clinicName" autofocus />
                </div>
              </div>

              <div class="form-group">
                <label for="medicalDegree" class="col-sm-3 offset-md-1 control-label">WorkingDays</label>
                <div class="col-sm-9 offset-md-1">
                  <p-multiSelect [options]="clinicDays" formControlName="weekDays" inputStyleClass="form-control"
                    autoWidth="false" [style]="{ width: '100%' }"></p-multiSelect>
                </div>
              </div>
              <div class="form-group">
                <label for="name" class="col-sm-3 offset-md-1 control-label">PatientLimit</label>
                <div class="col-sm-9 offset-md-1">
                  <input type="number" id="name" placeholder="patientLimit" class="form-control"
                    formControlName="patientLimit" autofocus />
                </div>
              </div>
              <div class="form-group">
                <label for="name" class="col-sm-3 offset-md-1 control-label">Opening Time</label>
                <div class="col-sm-9 offset-md-1">
                  <input type="time" name="starttime" class="form-control" formControlName="startTime" />
                </div>
              </div>
              <div class="form-group">
                <label for="name" class="col-sm-3 offset-md-1 control-label">Closing Time
                </label>
                <div class="col-sm-9 offset-md-1">
                  <input type="time" name="starttime" class="form-control" formControlName="endTime" />
                </div>
              </div>
              <div class="form-group">
                <label for="address" class="col-sm-3 offset-md-1 control-label">Address*</label>
                <div class="col-sm-9 offset-md-1">
                  <input type="text" id="address" placeholder="Address" class="form-control" formControlName="line1" />
                </div>
              </div>

              <div class="form-group">
                <label for="city" class="col-sm-3 offset-md-1 control-label">District*</label>
                <div class="col-sm-9 offset-md-1">
                  <input type="text" id="city" placeholder="district" class="form-control" formControlName="district" />
                </div>
              </div>

              <div class="form-group">
                <label for="city" class="col-sm-3 offset-md-1 control-label">City*</label>
                <div class="col-sm-9 offset-md-1">
                  <input type="text" id="city" placeholder="City" class="form-control" formControlName="city" />
                </div>
              </div>
              <div class="form-group">
                <label for="state" class="col-sm-3 offset-md-1 control-label">State*</label>
                <div class="col-sm-9 offset-md-1">
                  <select class="form-control" id="state" formControlName="state">
                    <option value="AP">Andhra Pradesh</option>
                    <option value="AR">Arunachal Pradesh</option>
                    <option value="AS">Assam</option>
                    <option value="BR">Bihar</option>
                    <option value="CG">Chhattisgarh</option>
                    <option value="GA">Goa</option>
                    <option value="GJ">Gujrat</option>
                    <option value="HR">Haryana</option>
                    <option value="HP">Himachal Pradesh</option>
                    <option value="JH">Jharkand</option>
                    <option value="KA">Karnataka</option>
                    <option value="KL">Kerla</option>
                    <option value="MP">Madhya Pradesh</option>
                    <option value="MH">Maharashtra</option>
                    <option value="MN">Manipur</option>
                    <option value="ML">Meghalaya</option>
                    <option value="MZ">Mizoram</option>
                    <option value="NL">Nagaland</option>
                    <option value="OD">Odisha</option>
                    <option value="PB">Punjab</option>
                    <option value="RJ">Rajasthan</option>
                    <option value="SK">Sikkim</option>
                    <option value="TN">Tamil Nadu</option>
                    <option value="TS">Telangana</option>
                    <option value="TR">Tripura</option>
                    <option value="UP">Uttar Pradesh</option>
                    <option value="UK">Uttarakhand</option>
                    <option value="WB">West Bengal</option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label for="pincode" class="col-sm-3 offset-md-1 control-label">PinCode*</label>
                <div class="col-sm-9 offset-md-1">
                  <input type="text" id="pincode" placeholder="Pincode" class="form-control"
                    formControlName="pincode" />
                </div>
              </div>

              <div class="col-sm-9 offset-md-1">
                <button class="btn btn-primary btn-block" style="border-radius: 10px" type="submit"
                  [disabled]="isLoading">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isLoading"></span>

                  Update ClinicData
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="myModalService">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" #servicebutton #closeservicemodal>
              &times;
            </button>
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            <form class="form-horizontal" [formGroup]="svForm" (ngSubmit)="onSubmitServiceData()">
              <h5 style="text-align: center">Add Services</h5>

              <div class="form-group">
                <label for="medicalDegree" class="col-sm-3  control-label">Service Name
                </label>

                <div class="col-sm-12 ">
                  <p-autoComplete formControlName="services" [(ngModel)]="texts" [suggestions]="dropdownList"
                    (completeMethod)="search($event)" [multiple]="true" [style]="{ width: '100%' }"
                    [inputStyle]="{ width: '30em' }" (onKeyUp)="onKeyUp($event)" autoWidth="true"></p-autoComplete>
                </div>
              </div>
              <div class="col-sm-9 offset-md-1">
                <button class="btn btn-primary btn-block" style="border-radius: 10px" type="submit"
                  [disabled]="isLoading">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isLoading"></span>

                  Add Services
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- modal for deleteHoliday -->
    <div class="modal fade" id="deleteHolidayModal">
      <div class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h6>Delete Holiday</h6>
            <button type="button" class="close" data-dismiss="modal" #closebutton #closedeleteholiday>
              &times;
            </button>
          </div>
          <div class="modal-body">
            <h5>Are you sure you want to delete?</h5>


            <div class="container">
              <div class="row">
                <button (click)="deleteHoliday()" class="btn btn-danger">
                  Delete
                </button>
                <button class="btn btn-light" data-dismiss="modal">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="myHoliday">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <!-- Modal Header -->

          <div class="modal-header">

            <button type="button" class="close" data-dismiss="modal" #holidaybutton #closeholidaymodal>
              &times;
            </button>
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            <form class="form-horizontal" [formGroup]="holForm" (ngSubmit)="OnSubmitHoliday()">
              <h5 style="text-align: center">Add Holidays</h5>

              <div class="form-group">
                <label for="startDate" class="col-sm-3 offset-md-1 control-label">Start Date
                </label>

                <div class="col-sm-9 offset-md-1">
                  <p-calendar id="startDate" [readonlyInput]="true" [style]="{ width: '100%' }"
                    formControlName="startDate" [inputStyle]="{ width: '100%' }" placeholder="start date"
                    inputStyleClass="text-center"></p-calendar>

                  <!--<p-multiSelect
                    [options]="services"
                    inputStyleClass="form-control"
                    autoWidth="false"
                    formControlName="services"
                    [style]="{ width: '100%' }"
                  ></p-multiSelect>-->
                </div>
              </div>
              <div class="form-group">
                <label for="endDate" class="col-sm-3 offset-md-1 control-label">End Date
                </label>

                <div class="col-sm-9 offset-md-1">
                  <p-calendar [readonlyInput]="true" id="endDate" formControlName="endDate" [style]="{ width: '100%' }"
                    [inputStyle]="{ width: '100%' }" placeholder="end date" inputStyleClass="text-center"></p-calendar>

                  <!--<p-multiSelect
                    [options]="services"
                    inputStyleClass="form-control"
                    autoWidth="false"
                    formControlName="services"
                    [style]="{ width: '100%' }"
                  ></p-multiSelect>-->
                </div>
              </div>

              <div class="col-sm-9 offset-md-1">
                <button class="btn btn-primary btn-block" style="border-radius: 10px" type="submit"
                  [disabled]="!holForm.valid || isLoading">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isLoading"></span>
                  Add Holidays
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="myNewClinic">
      <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" #closenewclinicbutton>
              &times;
            </button>
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            <form class="form-horizontal" [formGroup]="newcdForm" (ngSubmit)="onSubmitnewClinicData()">
              <h5 style="text-align: center">Add Clinic</h5>
              <div class="form-group">
                <label for="name" class="col-sm-3 offset-md-1 control-label">Clinic Name</label>
                <div class="col-sm-9 offset-md-1">
                  <input type="text" id="name" placeholder="Clinic name" class="form-control"
                    formControlName="clinicName" autofocus />
                </div>
              </div>

              <div class="form-group">
                <label for="medicalDegree" class="col-sm-3 offset-md-1 control-label">WorkingDays</label>
                <div class="col-sm-9 offset-md-1">
                  <p-multiSelect [options]="clinicDays" formControlName="weekDays" inputStyleClass="form-control"
                    autoWidth="false" [style]="{ width: '100%' }"></p-multiSelect>
                </div>
              </div>
              <div class="form-group">
                <label for="name" class="col-sm-3 offset-md-1 control-label">PatientLimit</label>
                <div class="col-sm-9 offset-md-1">
                  <input type="number" id="name" placeholder="patientLimit" class="form-control"
                    formControlName="patientLimit" />
                </div>
              </div>
              <div class="form-group">
                <label for="name" class="col-sm-3 offset-md-1 control-label">Opening Time</label>
                <div class="col-sm-9 offset-md-1">
                  <input type="time" name="starttime" class="form-control" formControlName="startTime" />
                </div>
              </div>
              <div class="form-group">
                <label for="name" class="col-sm-3 offset-md-1 control-label">Closing Time
                </label>
                <div class="col-sm-9 offset-md-1">
                  <input type="time" name="starttime" class="form-control" formControlName="endTime" />
                </div>
              </div>
              <div class="form-group">
                <label for="address" class="col-sm-3 offset-md-1 control-label">Address*</label>
                <div class="col-sm-9 offset-md-1">
                  <input type="text" id="address" placeholder="Address" class="form-control" formControlName="line1" />
                </div>
              </div>

              <div class="form-group">
                <label for="city" class="col-sm-3 offset-md-1 control-label">District*</label>
                <div class="col-sm-9 offset-md-1">
                  <input type="text" id="city" placeholder="district" class="form-control" formControlName="district" />
                </div>
              </div>

              <div class="form-group">
                <label for="city" class="col-sm-3 offset-md-1 control-label">City*</label>
                <div class="col-sm-9 offset-md-1">
                  <input type="text" id="city" placeholder="City" class="form-control" formControlName="city" />
                </div>
              </div>
              <div class="form-group">
                <label for="state" class="col-sm-3 offset-md-1 control-label">State*</label>
                <div class="col-sm-9 offset-md-1">
                  <select class="form-control" id="state" formControlName="state">
                    <option value="AP">Andhra Pradesh</option>
                    <option value="AR">Arunachal Pradesh</option>
                    <option value="AS">Assam</option>
                    <option value="BR">Bihar</option>
                    <option value="CG">Chhattisgarh</option>
                    <option value="GA">Goa</option>
                    <option value="GJ">Gujrat</option>
                    <option value="HR">Haryana</option>
                    <option value="HP">Himachal Pradesh</option>
                    <option value="JH">Jharkand</option>
                    <option value="KA">Karnataka</option>
                    <option value="KL">Kerla</option>
                    <option value="MP">Madhya Pradesh</option>
                    <option value="MH">Maharashtra</option>
                    <option value="MN">Manipur</option>
                    <option value="ML">Meghalaya</option>
                    <option value="MZ">Mizoram</option>
                    <option value="NL">Nagaland</option>
                    <option value="OD">Odisha</option>
                    <option value="PB">Punjab</option>
                    <option value="RJ">Rajasthan</option>
                    <option value="SK">Sikkim</option>
                    <option value="TN">Tamil Nadu</option>
                    <option value="TS">Telangana</option>
                    <option value="TR">Tripura</option>
                    <option value="UP">Uttar Pradesh</option>
                    <option value="UK">Uttarakhand</option>
                    <option value="WB">West Bengal</option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label for="pincode" class="col-sm-3 offset-md-1 control-label">PinCode*</label>
                <div class="col-sm-9 offset-md-1">
                  <input type="text" id="pincode" placeholder="Pincode" class="form-control"
                    formControlName="pincode" />
                </div>
              </div>

              <div class="col-sm-9 offset-md-1">
                <button class="btn btn-primary btn-block" style="border-radius: 10px" type="submit"
                  [disabled]="isLoading">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isLoading"></span>
                  Add Clinic
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Button trigger modal -->
  <!-- Modal -->
  <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Clinics</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" style="text-align: center;">
          <button type="button" class="btn btn-primary"  data-toggle="modal" data-target="#staticBackdrop">
            Add
          </button>
          <select class="form-control font-weight-bold mb-5" style="text-align-last: center"
            (change)="onclinicchange($event.target.value)">
            <option *ngFor="
                let clinic of clinicArray;
                let index = index
              " [value]="index" (change)="onChangeClinic($event.target.value)">
              {{ clinic.clinicName }}
            </option>
          </select>
          <table class="table table-striped">
            <thead *ngFor="let recep of showdata">
              <th>{{recep?.name}}</th>
              <th>{{recep?.email}}</th>
              <th>{{recep?.phoneNo}}</th>
              <i class="fa fa-trash-o" (click)="deleterecept(recep._id)" style="font-size: 30px;"
                aria-hidden="true"></i>
            </thead>
          </table>
          <!-- <i class="fa fa-pencil" aria-hidden="true"></i> -->
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="staticBackdropLabel">Receptionist Login</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span #closerecption aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form [formGroup]="addreceptionistform">
            <div class="input-group mb-3">
              <input type="text" formControlName="name" class="form-control" placeholder="Username"
                aria-label="Username" aria-describedby="basic-addon1">
              <div class="input-group-prepend">
                <span class="btn btn-info" id="basic-addon1"><i class="fa fa-user" aria-hidden="true"></i></span>
              </div>
            </div>
            <div class="input-group mb-3">
              <input type="text" class="form-control" formControlName="phoneNo" placeholder="Phone No."
                aria-label="Username" aria-describedby="basic-addon1">
              <div class="input-group-prepend">
                <span class="btn btn-info" id="basic-addon1"><i class="fa fa-phone" aria-hidden="true"></i></span>
              </div>
            </div>
            <div class="input-group mb-3">
              <input type="text" class="form-control" formControlName="email" placeholder="Email" aria-label="Username"
                aria-describedby="basic-addon1">
              <div class="input-group-prepend">
                <span class="btn btn-info" id="basic-addon1"><i class="fa fa-envelope-o" aria-hidden="true"></i></span>
              </div>
            </div>
            <div class="input-group mb-3">
              <input type="text" class="form-control" formControlName="password" placeholder="Passsword"
                aria-label="password" aria-describedby="basic-addon1">
              <div class="input-group-prepend">
                <span class="btn btn-info" id="basic-addon1"><i class="fa fa-unlock-alt" aria-hidden="true"></i></span>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" #closerecption data-dismiss="modal">Close</button>
          <button type="button" [disabled]="!addreceptionistform.valid" (click)="addreceptionist()"
            class="btn btn-primary">Add</button>
        </div>
      </div>
    </div>
  </div>
</body>